/** One product release; bump `ATW_ONE_VERSION` at repo root (next: 27.2.080). */
import oneReleaseRaw from "../../ATW_ONE_VERSION?raw";

const ATW_ONE_RELEASE_VERSION = oneReleaseRaw.trim();

const SIDEBAR_FOOTER_PRODUCT_NAME = "ATW One";

export type AppVersionInfo = {
  version: string;
  buildId: string;
  releaseVersion: string;
};

export function getAppVersion(): AppVersionInfo {
  const buildId = import.meta.env.VITE_APP_BUILD_ID?.trim() || "local";
  return {
    version: ATW_ONE_RELEASE_VERSION,
    buildId,
    releaseVersion: ATW_ONE_RELEASE_VERSION,
  };
}

export function formatAppVersionLabel(info: AppVersionInfo): string {
  const buildPart = info.buildId !== "local" ? ` (#${info.buildId})` : "";
  return `${info.version}${buildPart}`;
}

export function formatSidebarFooterLine(): string {
  return `${SIDEBAR_FOOTER_PRODUCT_NAME} · V${ATW_ONE_RELEASE_VERSION}`;
}
